export { LocalStorageWrapper } from './localStorageWrapper';
export { SessionStorageWrapper } from './sessionStorageWrapper';
export { StorageManager } from './storageManager';
export { IStorage } from './interfaces/iStorage';